import React, { Component } from 'react'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import { Row, Col } from 'antd'
import Seq from './seq'
import ExamCard from './exam-card'
import { selectFromArray } from 'helper'

class Exam extends Component {
  state = {
    exams: [],
    current: 0,
  }

  componentDidMount() {
    window.localStorage.clear()
    this.prepareExams()
  }

  prepareExams = async () => {
    try {
      const res = await axios.get(`https://cdn-static.sspai.com/page/event_2018/question.json?${new Date()}`)
      const { data } = res
      const shuffledExams = selectFromArray(data, 10)
      this.setState({
        exams: shuffledExams,
      })
    } catch (err) {
      console.warn('Failed to initialize exams', err)
    }
  }

  handleOptionClick = option => {
    const currentPoint = Number(window.localStorage.getItem('sspai_point')) || 0
    const currentTagsStorage = window.localStorage.getItem('sspai_tags') || '[]'
    let currentTags
    try {
      currentTags = JSON.parse(currentTagsStorage)
    } catch (err) {
      currentTags = []
    }

    if (option.tag) {
      currentTags.push(option.tag)
    }

    window.localStorage.setItem('sspai_tags', JSON.stringify(currentTags))
    window.localStorage.setItem('sspai_point', Number(option.sspai_point) + currentPoint)

    setTimeout(() => {
      const { current } = this.state
      if (current >= 9) {
        this.props.history.push('/name-form')
      } else {
        this.setState({
          current: this.state.current + 1,
        })
      }
    }, 500)
  }

  render() {
    const { current, exams } = this.state

    return (
      <Row style={{ maxWidth: 400, margin: '0 auto' }}>
        <Col>
          <Row
            style={{
              marginTop: 20,
              textAlign: 'center',
              height: 50,
              boxShadow: 'rgba(37, 37, 37, 0.26) 1px 7px 6px 0px',
            }}
          >
            <Col>
              <Seq current={current} seq={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]} />
            </Col>
          </Row>

          <Row>
            <Col>
              {exams[current] ? (
                <ExamCard current={current} data={exams[current]} handleOptionClick={this.handleOptionClick} />
              ) : null}
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default withRouter(Exam)
